import axios from "axios";
import domain from "@/util/domain.js";
import {
  getIntegrationIdByName,
  addUserIntegration,
} from "./integrationsUtils.js";

const host = domain();
// Access-Control-Allow-* são headers de resposta: enviados na requisição só
// aumentam a lista que o preflight do API Gateway precisa liberar.
const headers = {
  "Content-Type": "application/json",
};
// Stack sga-lambda-rdstation-prod (us-east-2). Não há stack de dev em us-east-2:
// o "dev" fica nulo para que um operador de teste nunca grave no CRM de prd.
const baseLambdaURLs = {
  dev: null,
  prod: "https://feztepda1k.execute-api.us-east-2.amazonaws.com",
};
let operator;
const rdStationIntegrationId = getIntegrationIdByName("rdStation");

//? Constructor RdStation
//* https://developers.rdstation.com/reference/introducao-rdsm
class RdStation {
  constructor(
    rdStationActive = false,
    createUser = false,
    confirmRegister = false,
    firstDeposit = false,
    baseLambdaURL = baseLambdaURLs.prod
  ) {
    this.rdStationActive = rdStationActive;
    this.baseLambdaURL = baseLambdaURL;
    this.createUser = createUser;
    this.confirmRegister = confirmRegister;
    this.firstDeposit = firstDeposit;
  }
}

//? Integrando ao Vue
export default {
  install(Vue) {
    Vue.prototype.$rdStation = async (action, userData, userId) => {
      //? Montando o Construtor do operador
      //! Para testes, comente o "case" que não será utilizado entre cartola ou sysbet para que
      //! não habilite a integração em dois ambientes desnecessariamente
      switch (host) {
        case "sysbet":
        case "homolog":
          operator = new RdStation(false, true, true, true, baseLambdaURLs.dev);
          break;
        case "jogodeourobet":
        case "betfolia":
        case "overbets":
        case "betdasorte":
        case "pixpremioesporte":
        case "8bets":
          operator = new RdStation(true, true, true, true);
          break;
        default:
          operator = new RdStation();
      }

      if (!operator.rdStationActive) return;

      //? Criação de Usuário - createUser
      if (action === "createUser" && operator.createUser) {
        const responseCreateUser = await createUser(userData, userId);

        if (responseCreateUser.status !== 200) return;

        // Adicionando ID do usuário do RdStation no banco de dados para que
        // quando o usuário confirmar sua conta, esse ID seja utilizado para
        // atualizar o status de confirmação de conta nos dados do usuário no
        // rdStation
        const userIdRdStation = responseCreateUser.data.userIdRdStation;

        addUserIntegration(userId, userIdRdStation, "rdStation");
      }

      //? Confirmação de Conta - confirmRegister
      if (action === "confirmRegister" && operator.confirmRegister) {
        const userIntegrations = userData.integrations;

        if (userIntegrations && userIntegrations.length !== 0) {
          const hasIntegrationId = userIntegrations.find((integration) => {
            const { integration_id, user_integration_id } = integration;

            return (
              rdStationIntegrationId === integration_id && user_integration_id
            );
          });

          if (!hasIntegrationId) return;

          const responseUpdateUser = await updateUser(
            hasIntegrationId,
            "confirmRegister"
          );

          if (responseUpdateUser.status !== 200) return;
        }

        return;
      }

      //? Primeiro Depósito - firstDeposit
      if (action === "firstDeposit" && operator.firstDeposit) {
        Vue.prototype.$axios
          .post(
            "/player/profile/findPlayerIntegrationId",
            Vue.prototype.$formdata({ integration_id: rdStationIntegrationId })
          )
          .then(async (resp) => {
            const respUserData = resp.data.dados;

            if (!respUserData.user_integration_id) return;

            const responseUpdateUser = await updateUser(
              respUserData,
              "firstDeposit"
            );

            if (responseUpdateUser.status !== 200) return;
          })
          .catch(() => {});
      }
    };
  },
};

//? Create Contact
//* https://developers.rdstation.com/reference/post_platform-contacts
const createUser = async (userData, userId) => {
  return new Promise(function(resolve, reject) {
    const body = {
      domain: userData.domain,
      user: {
        nome: userData.nome,
        email: userData.email,
        celular: userData.celular,
        cpf: userData.cpf,
        login: userData.login,
        userId,
      },
    };

    axios
      .post(`${operator.baseLambdaURL}/createUserRdStation`, body, { headers })
      .then((resp) => resolve(resp))
      .catch((err) => reject(err));
  });
};

//? Update User Field
//* https://developers.rdstation.com/reference/post_platform-contacts-identifier-value-tag (Adicionar tag ou tags)
//* https://developers.rdstation.com/reference/patch_platform-contacts-identifier-value (Remover tags existente e adicionar nova(s))
const updateUser = async (userData, typeData) => {
  return new Promise(function(resolve, reject) {
    const body = {
      domain: domain(),
      userIdRdStation: userData.user_integration_id,
      typeData,
    };

    axios
      .post(`${operator.baseLambdaURL}/updateUserRdStation`, body, { headers })
      .then((resp) => resolve(resp))
      .catch((err) => reject(err));
  });
};
